"use client"

import { SignUp } from "@clerk/nextjs";
import { useSearchParams } from "next/navigation";
import { useState, useEffect } from "react";

export default function SignUpClient() {
  const searchParams = useSearchParams()
  const redirectParam = searchParams.get("redirect_url") || "/home"
  const [origin, setOrigin] = useState('')

  useEffect(() => {
    setOrigin(window.location.origin)
  }, [])

  const redirectUrl = redirectParam.startsWith("http") ? redirectParam : `${origin}${redirectParam}`

  return (
    <div className="flex min-h-screen items-center justify-center bg-background relative overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-100/40 via-background to-background dark:from-blue-900/20" />
      <SignUp forceRedirectUrl={redirectUrl} signInForceRedirectUrl={redirectUrl} />
    </div>
  );
}
